import axiosInstance from "../../utils/axios";

const uploadImage = async (formData) => {
  try {
    const response = await axiosInstance.post("/product/uploadImage", formData);
    return response.data; // Assuming the API returns filePath or similar
  } catch (err) {
    console.error("Error uploading image:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const createProduct = async (values) => {
  try {
    // Log all files
    values.getAll("file[]").forEach((file) => {
      // console.log("Creating customer with file:", file);
    });

    const response = await axiosInstance.post("/product/createProduct", values);
    console.log(response);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    );
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const setPriceProduct = async (values) => {
  try {
    const response = await axiosInstance.patch(
      "/product/setSellPriceProduct",
      values
    );
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    );
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createSellOrder = async (values) => {
  // console.log("values", values);
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post(
      "/product/createSellOrder",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createCustomer = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post(
      "/product/createCustomer",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createLendCustomer = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post(
      "/product/createLendCustomer",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createSellCustomer = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post(
      "/product/createSellCustomer",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateProduct = async (values) => {
  try {
    // Log all files
    values.getAll("file[]").forEach((file) => {
      // console.log("Creating customer with file:", file);
    });

    const response = await axiosInstance.patch(
      "/product/updateProduct",
      values
    );
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    );
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateOrderBorrow = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.patch(
      "/product/changeToReturnOrder",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const updateCustomer = async (values) => {
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.patch(
      "/product/updateCustomer",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};
const createOrder = async (values) => {
  // console.log("values", values);
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post("/product/createOrder", values);
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const createLendOrder = async (values) => {
  // console.log("values", values);
  try {
    // console.log("Creating customer with values:", values); // Log the values
    const response = await axiosInstance.post(
      "/product/createLendOrder",
      values
    );
    // console.log("Customer creation response:", response.data); // Log the detailed response
    // console.log('',response.data);
    return response.data;
  } catch (err) {
    console.error(
      "Error creating order:",
      err.response ? err.response.data : err.message
    ); // Log detailed error
    alert(err.response ? err.response.data.message : err.message);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const getOrder = async () => {
  try {
    const response = await axiosInstance.get("/product/getOrder");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);

    throw err; // Propagate error to handle it in the calling function
  }
};

const getAllOrders = async () => {
  try {
    const response = await axiosInstance.get("/product/getAllOrders");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getOrderByCustomer = async () => {
  try {
    const response = await axiosInstance.get("/product/getListOrderByCustomer");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getCustomerList = async () => {
  try {
    const response = await axiosInstance.get("/product/customerLists");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getSoldOrders = async () => {
  try {
    const response = await axiosInstance.get("/product/getSoldOrders");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getLendAndReturnOrders = async () => {
  try {
    const response = await axiosInstance.get("/product/getLendAndReturnOrders");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    alert(err.response ? err.response.data.message : err.message);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getReadyOrders = async () => {
  try {
    const response = await axiosInstance.get("/product/getSellOrders");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);

    throw err; // Propagate error to handle it in the calling function
  }
};

const getSellOrdersToSetPrice = async () => {
  try {
    const response = await axiosInstance.get(
      "/product/getSellOrdersToSetPrice"
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getAllProductLendAndReturnpage = async () => {
  try {
    const response = await axiosInstance.get(
      "/product/getAllProductLendAndReturnpage"
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getProduct = async () => {
  try {
    const response = await axiosInstance.get("/product/getProduct");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getProductForCreateLendOrder = async (values) => {
  try {
    const response = await axiosInstance.get(
      `/product/getProductForCreateLendOrder/${values}`
    );
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getOverDueOrders = async () => {
  try {
    const response = await axiosInstance.get("/product/getOverDueOrders");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const getCustomerLists = async () => {
  try {
    const response = await axiosInstance.get("/product/customerLists");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const getOneOrder = async () => {
  try {
    const response = await axiosInstance.get("/getOneOrder");
    // console.log("response.data", response.data);
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getInventory = async () => {
  try {
    const response = await axiosInstance.get("/product/getInventory");
    return response.data;
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getInterest = async () => {
  try {
    const response = await axiosInstance.get("/product/getInterest");
    return response.data;
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getAllOrderAccount = async () => {
  try {
    const response = await axiosInstance.get("/product/getAllOrderAccount");
    return response.data;
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const getDashboard = async () => {
  try {
    const response = await axiosInstance.get("/product//getDashboard");
    return response.data;
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

//export excel
const exportExcelBuyProduct = async () => {
  try {
    return await axiosInstance.get("/product/exportExcelBuyProduct", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const exportExcelSellProduct = async () => {
  try {
    return await axiosInstance.get("/product/exportExcelSellProduct", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const exportExcelSoldProduct = async () => {
  try {
    return await axiosInstance.get("/product/exportExcelSoldProduct", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const exportExcelLendOrder = async () => {
  try {
    return await axiosInstance.get("/product/exportExcelLendOrder", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const exportExcelOverDueProducts = async () => {
  try {
    return await axiosInstance.get("/product/exportExcelOverDueProducts", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const exportExcelListOrderByCustomer = async (id) => {
  try {
    return await axiosInstance.get(`/product/exportExcelListOrderByCustomer`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const exportExcelCustomerList = async () => {
  try {
    return await axiosInstance.get("/product/exportCustomerListsExcel", {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const getGenerateAndPrintPdfBuyProduct = async (order_id) => {
  try {
    return await axiosInstance.get(`/product/print-pdf/${order_id}`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error creating order:", err);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const getGenerateAndPrintPdfSellOrder = async (order_sell_id) => {
  try {
    return await axiosInstance.get(
      `/product/print-pdf-sellOrder/${order_sell_id}`,
      {
        responseType: "blob",
      }
    );
  } catch (err) {
    console.error("Error creating order:", err);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const getPrintPdfLendOrder = async (order_id) => {
  try {
    return await axiosInstance.get(`/product/printPdfLendOrder/${order_id}`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error creating order:", err);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const getPrintPdfReturnOrder = async (order_id) => {
  try {
    return await axiosInstance.get(`/product/printPdfReturnOrder/${order_id}`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error creating order:", err);
    return {
      isStatus: false,
      data: null,
      message: err.response ? err.response.data.message : err.message,
    };
  }
};

const ProductAPI = {
  uploadImage,
  createProduct,
  createCustomer,
  updateProduct,
  updateCustomer,
  createOrder,
  getOrder,
  getOneOrder,
  getProduct,
  getReadyOrders,
  createSellOrder,
  createSellCustomer,
  getAllProductLendAndReturnpage,
  createLendCustomer,
  createLendOrder,
  getLendAndReturnOrders,
  getCustomerLists,
  updateOrderBorrow,
  getOverDueOrders,
  getSellOrdersToSetPrice,
  getSoldOrders,
  setPriceProduct,
  getCustomerList,
  getOrderByCustomer,
  getProductForCreateLendOrder,
  getInventory,
  getInterest,
  getAllOrderAccount,
  getAllOrders,
  getDashboard,

  //export excel
  exportExcelBuyProduct,
  exportExcelSellProduct,
  exportExcelSoldProduct,
  exportExcelLendOrder,
  exportExcelOverDueProducts,
  exportExcelListOrderByCustomer,
  exportExcelCustomerList,

  // print pdf
  getGenerateAndPrintPdfBuyProduct,
  getGenerateAndPrintPdfSellOrder,
  getPrintPdfLendOrder,
  getPrintPdfReturnOrder,
};

export default ProductAPI;
